import React, { useEffect, useRef } from "react"
import { useSocket } from "../contexts/SocketContext"
// import { useAuth } from "../contexts/AuthContext"
import Avatar from "./Avatar"
import { useReduxStore } from "../hooks/useReduxStore"
import { ImageUrl } from "../services/API"
const doc=require("../assets/doc.png")
const MessageList = ({ messages, currentUserId, conversationId }) => {
  const {getState}=useReduxStore()
  const {userData}=getState("AUTH")
  const {adminData,adminToken}=getState("ADMIN_AUTH")
  const messagesEndRef = useRef(null)
  const { markAsSeen } = useSocket()
  // const { user } = useAuth()
  const user=Boolean(adminToken)?adminData:userData

  useEffect(() => {
    scrollToBottom()
  }, [messages])

  useEffect(() => {
    // Only mark messages as seen if we have a valid conversation
    if (!conversationId) {
      console.log("⚠️ No conversationId available, skipping mark as seen")
      return
    }

    // Mark messages as seen when they come into view
    const unseenMessages = messages.filter(
      msg => msg.senderId !== currentUserId && !msg.isSeen
    )

    if (unseenMessages.length > 0) {
      // Mark the latest unseen message as seen
      const latestUnseenMessage = unseenMessages[unseenMessages.length - 1]
      console.log(
        "👁️ Marking message as seen:",
        latestUnseenMessage._id,
        "in conversation:",
        conversationId
      )
      markAsSeen(latestUnseenMessage._id, conversationId)
    }
  }, [messages, currentUserId, conversationId, markAsSeen])

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      })
    }
  }

  const formatTime = dateString => {
    const date = new Date(dateString)
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  }

  const formatDate = dateString => {
    const date = new Date(dateString)
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)

    if (date.toDateString() === today.toDateString()) {
      return "Today"
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday"
    } else {
      return date.toLocaleDateString()
    }
  }
  const handleDownload = async (message) => {
    try {
      const fileUrl = `${ImageUrl}${message.fileUrl}`;
      const fileName =
        message.fileName ||
        fileUrl.split("/").pop() ||
        "download";
  
      // Fetch file as binary blob
      const response = await fetch(fileUrl, {
        mode: "cors",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });
  
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }
  
      const blob = await response.blob();
  
      // Create blob link and trigger download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
  
      // Free memory
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("❌ File download failed:", error);
      alert("⚠️ File download failed. Check console or backend logs.");
    }
  };
  
  
  const renderMessage = (message, index) => {
    // Try multiple ways to get current user ID
    const currentUserIds = [currentUserId, user?._id, user?.id].filter(Boolean)

    // Multiple ways to check if it's own message
    const isOwnMessage = currentUserIds.some(
      id =>
        message.senderId === id ||
        message.sender?._id === id ||
        message.sender?.id === id ||
        String(message.senderId) === String(id)
    )
    let  senderName = message.sender?.name || "Unknown User"
        senderName=senderName==="Administrator"?"Meteorologist":senderName
    // Debug logging
    console.log("🔍 Message debug:", {
      messageId: message._id,
      senderId: message.senderId,
      senderIdType: typeof message.senderId,
      currentUserId: currentUserId,
      currentUserIdType: typeof currentUserId,
      senderObjectId: message.sender?._id,
      senderObjectIdAlt: message.sender?.id,
      isOwnMessage: isOwnMessage,
      senderName: senderName,
      messageText: message.text?.substring(0, 20) + "..."
    })

    // Check if this is the first message of the day
    const showDateHeader =
      index === 0 ||
      formatDate(message.createdAt) !==
        formatDate(messages[index - 1].createdAt)
const getExt=(name)=>{
  return name?.split(".").pop()
}
    return (
      <div key={`${message._id}-${index}`} className="w-full">
        {/* Date Header */}
        {showDateHeader && (
          <div className="flex justify-center my-5 relative">
            <div className="bg-[#f0f0f0] text-[#666] px-3 py-1.5 rounded-xl text-xs font-medium">
              {formatDate(message.createdAt)}
            </div>
          </div>
        )}

        {/* Message Container */}
        <div
          className={`flex mb-2 px-2 sm:px-4 ${
            isOwnMessage ? "justify-end" : "justify-start"
          }`}
        >
          {/* Other person's message */}
          {!isOwnMessage && (
            <div className="flex items-end gap-2 max-w-[90%] sm:max-w-[80%] md:max-w-[70%]">
              {/* Avatar */}
              <Avatar name={senderName} size="small" />

              {/* Message Bubble */}
              <div
                className="bg-borderGray rounded-tr-2xl rounded-tl-2xl rounded-bl-sm rounded-br-2xl p-2 sm:p-3 shadow-sm relative max-w-full sm:max-w-[60vw] md:max-w-[40vw]"
              >
                {/* Sender Name */}
                <div className="text-xs font-semibold text-white mb-1">
                  {senderName}
                </div>

                {/* Message Content */}
                <div className="mb-1">
                  {message.messageType === "text" && (
                    <div className="text-sm sm:text-base leading-relaxed text-white break-words whitespace-pre-wrap">
                      {message.text}
                    </div>
                  )}

                  {/* {message.messageType === "file" && (
                    <div>
                      <div style={{ fontWeight: "500", marginBottom: "5px",color:"white" }}>
                        📎 {message.fileName || "File"}
                      </div>
                      {message.fileType?.startsWith("image/") && (
                        <img
                          src={`${ImageUrl}${message.fileUrl}`}
                          alt={message.fileName}
                          style={{
                            maxWidth: "200px",
                            maxHeight: "200px",
                            borderRadius: "8px",
                            marginTop: "5px"
                          }}
                        />
                      )}
                    </div>
                  )} */}
  {message.messageType === "file" && (
  <div className="relative inline-block rounded-lg overflow-hidden cursor-pointer group">
    <div className="font-medium mb-1 text-white flex items-center gap-2 text-xs sm:text-sm">
      {/* <span>📎</span> */}
      <span>{message.fileType?.startsWith("image/")?"image" : "document"}.{getExt(message.fileUrl)}</span>
    </div>

    {/* Image preview (if file is image) */}
    {message.fileType?.startsWith("image/") ? (
      <img
        src={`${ImageUrl}${message.fileUrl}`}
        alt={message.fileName}
        className="max-w-full sm:max-w-[200px] max-h-[200px] rounded-lg mt-1 block transition-transform duration-300 group-hover:scale-105"
      />
    ):(
      <img
        src={doc}
        alt={message.fileName}
        className="w-20 h-20 sm:w-28 sm:h-28 rounded-lg mt-1 block transition-transform duration-300 group-hover:scale-105"
      />
    )
    }

    {/* Hover Download Button */}
    <button
      onClick={()=>{handleDownload(message)}}
      download // 👈 this ensures browser tries to download instead of open
      title="Download file"
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                 bg-white/90 text-blue-600 rounded-full w-12 h-12 shadow-lg hidden 
                 group-hover:flex items-center justify-center transition-all duration-300
                 hover:bg-blue-600 hover:text-white hover:scale-110 z-50"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
      </svg>
    </button>
  </div>
)}



                  {message.messageType === "voice" && (
                    <div
                      style={{
                        // background: "#f8f9fa",
                        borderRadius: "8px",
                        padding: "8px 0px",
                        // border: "1px solid #e9ecef",
                        minWidth:"20vw"

                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          marginBottom: "8px",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        🎤 Voice Message
                        <span
                          style={{
                            fontSize: "11px",
                            color: "white",
                            fontWeight: "normal"
                          }}
                        >
                          {message.voiceDuration
                            ? `${message.voiceDuration}s`
                            : "Unknown duration"}
                        </span>
                      </div>
                      <audio
                        controls
                        className="w-full h-10 rounded"
                        src={`${ImageUrl}${message.voiceUrl}`}
                        preload="metadata"
                      />
                    </div>
                  )}
                </div>

                {/* Time */}
                <div className="text-[10px] sm:text-[11px] text-white text-left">
                  {formatTime(message.createdAt)}
                </div>
              </div>
            </div>
          )}

          {/* Own message */}
          {isOwnMessage && (
            <div className="flex items-end gap-2 max-w-[90%] sm:max-w-[80%] md:max-w-[70%] flex-row-reverse">
              {/* Message Bubble */}
              <div
                className="bg-primaryBlue rounded-tr-2xl rounded-tl-2xl rounded-bl-2xl rounded-br-sm p-2 sm:p-3 shadow-sm relative max-w-full sm:max-w-[60vw] md:max-w-[40vw]"
              >
                {/* Message Content */}
                <div className="mb-1">
                  {message.messageType === "text" && (
                    <div className="text-sm sm:text-base leading-relaxed text-white break-words whitespace-pre-wrap">
                      {message.text}
                    </div>
                  )}

{message.messageType === "file" && (
  <div className="relative inline-block rounded-lg overflow-hidden cursor-pointer group">
    <div className="font-medium mb-1 text-white flex items-center gap-2 text-xs sm:text-sm">
      {/* <span>📎</span> */}
      <span>{message.fileType?.startsWith("image/")?"image" : "document"}.{getExt(message.fileUrl)}</span>

    </div>

    {/* Image preview (if file is image) */}
    {message.fileType?.startsWith("image/") ?(
      <img
        src={`${ImageUrl}${message.fileUrl}`}
        alt={message.fileName}
        className="max-w-full sm:max-w-[200px] max-h-[200px] rounded-lg mt-1 block transition-transform duration-300 group-hover:scale-105"
      />
    ):(
      <img
        src={doc}
        alt={message.fileName}
        className="w-28 h-28 rounded-lg mt-1 block transition-transform duration-300 group-hover:scale-105"
      />
    )
  }

    {/* Hover Download Button */}
    <button
      onClick={()=>{handleDownload(message)}}
      download // 👈 this ensures browser tries to download instead of open
      title="Download file"
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                 bg-white/90 text-blue-600 rounded-full w-12 h-12 shadow-lg hidden 
                 group-hover:flex items-center justify-center transition-all duration-300
                 hover:bg-blue-600 hover:text-white hover:scale-110"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
      </svg>
    </button>
  </div>
)}

                  {message.messageType === "voice" && (
                    <div
                      style={{
                        // background: "#ffffff",
                        borderRadius: "8px",
                        padding: "8px 0px",
                        // border: "1px solid #e9ecef",
                        minWidth:"20vw"
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          marginBottom: "8px",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        🎤 Voice Message
                        <span
                          style={{
                            fontSize: "11px",
                            color: "white",
                            fontWeight: "normal"
                          }}
                        >
                          {message.voiceDuration
                            ? `${message.voiceDuration}s`
                            : "Unknown duration"}
                        </span>
                      </div>
                      <audio
                        controls
                        style={{
                          width: "100%",
                          height: "40px",
                          borderRadius: "4px"
                        }}
                        src={`${ImageUrl}${message.voiceUrl}`}
                        preload="metadata"
                      />
                    </div>
                  )}
                </div>

                {/* Time and Status */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "4px",
                    fontSize: "11px",
                    color: "white"
                  }}
                >
                  <span>{formatTime(message.createdAt)}</span>
                  {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                    {message.isDelivered && (
                      <span style={{ color: '#999', marginRight: '2px' }}>✓</span>
                    )}
                    {message.isSeen && (
                      <span style={{ color: '#4fc3f7' }}>✓</span>
                    )}
                    {!message.isDelivered && (
                      <span style={{ color: '#ccc', marginRight: '2px' }}>✓</span>
                    )}
                  </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div
      className="flex-1 overflow-y-scroll py-2 h-full max-h-full scroll-smooth bg-blueGray"
    >
      {messages.length === 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#666",
            textAlign: "center"
          }}
        >
          <div>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>💬</div>
            <h3 style={{ margin: "0 0 8px 0", color: "white" }}>
              No messages yet
            </h3>
            <p style={{ margin: 0, fontSize: "14px",color: "gray" }}>
              Start the conversation by sending a message!
            </p>
          </div>
        </div>
      ) : (
        <div>
          {messages.map((message, index) => renderMessage(message, index))}
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  )
}

export default MessageList

